/**
 * deliveryProofAccess.ts — ai thấy nút "Tải ảnh bàn giao" trên đơn ảnh thẻ.
 *
 * CEO chốt 29/09/2026 (3a · 4): thợ chụp của đơn tải được TỪ LÚC được xếp ca
 * (ảnh thẻ: được xếp là đã nhận ca, QĐ 0234), cộng những vai được giao đơn
 * (CSKH, trưởng cửa hàng, ban điều hành) — hôm thợ bận thì người trả ảnh thật
 * vẫn tải được. Gương của `proof.Service.Add` nhánh `KindDelivery` bên máy
 * chủ: đứng suất chụp của đơn HOẶC vai qua được `completed → delivered`.
 *
 * Tách tệp riêng (không để ở utils.ts) vì `orders/transitions.ts` đã import
 * utils.ts — đặt ở đó là vòng import.
 */
import { getRoleKey, ROLE_TRANSITIONS, type UserForTransitions } from "@/features/orders/transitions";
import { isIdPhotoOrder } from "./utils";

export interface DeliveryProofOrder {
  status: string;
  category?: string | null;
  product?: string | null;
  productId?: string | null;
  photographers?: { id: string }[] | null;
}

/**
 * Vai được giao đơn — đọc đúng bảng chuyển trạng thái mà máy chủ soi, không
 * chép danh sách vai riêng (chép là lệch: vai Điều phối đã khoá 23/08/2026).
 */
export function roleMayDeliver(user: UserForTransitions | null | undefined): boolean {
  return (ROLE_TRANSITIONS[getRoleKey(user)]?.completed ?? []).includes("delivered");
}

/**
 * Hiện khối ảnh bàn giao hay không. Đơn huỷ thì thôi. Thợ chụp nhận ca qua
 * suất tạm (claim) màn này không thấy được — máy chủ vẫn nhận ảnh của họ, và
 * thẻ ca ở trang chủ (đọc cờ `isPhoto` của máy chủ) vẫn có nút cho họ.
 */
export function canAddDeliveryProof(
  user: UserForTransitions | null | undefined,
  myStaffId: string | null | undefined,
  order: DeliveryProofOrder,
): boolean {
  if (order.status === "cancelled" || !isIdPhotoOrder(order)) return false;
  const onPhotoSlot = !!myStaffId && (order.photographers ?? []).some((m) => m.id === myStaffId);
  return onPhotoSlot || roleMayDeliver(user);
}
